import { render, staticRenderFns } from "./ImageClipboardUploader.vue?vue&type=template&id=40478f46"
import script from "./ImageClipboardUploader.vue?vue&type=script&lang=js"
export * from "./ImageClipboardUploader.vue?vue&type=script&lang=js"
import style0 from "./ImageClipboardUploader.vue?vue&type=style&index=0&id=40478f46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports